import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth } from "firebase/auth";
import { env } from "@config";

const firebaseApp = initializeApp(env.firebaseConfig, env.firebaseAppName);

export const firebaseAuth = getAuth(firebaseApp);

firebaseAuth.setPersistence(browserLocalPersistence);
